var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('transition',{attrs:{"name":"comment-fade-down"}},[_c('router-view',{staticClass:"g-comment",attrs:{"name":"comment"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }